import { authClient, API } from "../index";

// Get all texts
export const getTexts = () => {
  return authClient().get(`${API}/text`);
};

// Get text by id
export const getTextById = (id) => {
  return authClient().get(`${API}/text/${id}`);
};
